module.exports = __webpack_public_path__ + "static/media/bts_boots_170812_004_small.caf60487.jpg";